// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_member_info_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { JepxMemberInfoService } from "./jepx_member_info_service_pb";

/**
 * GetJepxMemberInfo returns the organization's JEPX 連携マスタ情報.
 * member_info is unset when 未設定 (= the frontend renders the empty state
 * per AC-IJM-003)。 fee_schedule is always populated.
 *
 * @generated from rpc bffuser.v1.JepxMemberInfoService.GetJepxMemberInfo
 */
export const getJepxMemberInfo = JepxMemberInfoService.method.getJepxMemberInfo;
